import { useQuery } from "react-query";
import { getAllAboutImages } from "../Services/Https/about-images";

export const useAllAboutImages = () => {
  return useQuery(["about-images"], () => getAllAboutImages(), {
    keepPreviousData: true,
  });
};
